<template>
    <Dialog
        v-if="taskLog"
        :value="true"
        :header-text="taskLog ? taskLog.subject : $t('Email')"
        hide-footer
        persistent
        full-content-width
        :width="700"
        @close_modal="$emit('close')"
    >
        <template #header>
            <div class="d-flex align-start flex-grow-1 flex-wrap" style="max-width: 100%;">
                <span class="font-weight-medium text-truncate">
                    {{ taskLog ? taskLog.subject : $t('Email') }}
                </span>
                <div class="d-flex align-center ml-auto overflow-hidden ml-auto mt-1">
                    <ClientAvatar
                        v-if="taskLog.client"
                        :initials="taskLog.client.client_initials"
                        :color="taskLog.client.color"
                        :size="24"
                    />
                    <div
                        class="n4--text cursor-pointer body-2 ml-2 text-truncate"
                        @click="onViewTask"
                    >
                        {{ taskLog.task && taskLog.task.title ? taskLog.task.title : $t('Task') }}
                    </div>
                </div>
            </div>
        </template>
        <div class="d-flex justify-end">
        </div>
        <div class="pb-10">
            <EmailBody :item="taskLog" />
        </div>
    </Dialog>
</template>

<script>
import Dialog from "@/components/Dialog.vue";
import EmailDetails from "@/views/Client/Communication/History/EmailDetails";
import { formatDateTime } from "@/plugins/formatting"
import EmailBody from "@/components/Emailing/EmailBody/Index.vue"
import TaskModule from "@/store/modules/task"
import ClientAvatar from "@/components/ClientAvatar.vue";

export default {
    name: "IncomingEmailDialog",
    components: {
        ClientAvatar,
        Dialog,
        EmailDetails,
        EmailBody
    },
    props: {
        taskLog: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const { openTask } = TaskModule()

        const onViewTask = () => {
            openTask(props.taskLog.task_id)
        }

        return {
            formatDateTime,
            openTask,
            onViewTask
        };
    }
};
</script>